import { FormGroup } from "@angular/forms";
import { CreateUser } from "../models/user";

export function createNewUser(userForm: FormGroup): CreateUser {
    const form = userForm.getRawValue();

    return {
        username: form['email'],
        firstName: form['firstName'],
        lastName: form['lastName'],
        email: form['email'],
        password: form['password'],
        repeatPassword: form['repeatPassword'],
        group: form['group']
    }
}